import * as React from 'react';
import AuthContext from '../../../Context/AuthContext';
import { SlimUser } from '../../../Core/Api/Api';
import AuthUser from 'Core/models/AuthUser';
import TokenService from 'Core/TokenService';
import ConfigService from 'Core/ConfigService';

export interface Props {
  children?: React.ReactNode;
}

export interface State {
  currentUser?: AuthUser;
  shouldRenderChildren?: boolean;
  userCheckInterval?: any;
}

export default class AuthContextProvider extends React.Component<Props, State> {
  update: (newUser: any) => void;

  constructor(props: Props) {
    super(props);

    this.state = { currentUser: undefined, shouldRenderChildren: false };
    this.updateUserBasedOnToken = this.updateUserBasedOnToken.bind(this);
    this.update = this.updateContextAndCheckToken;
    }

    shouldComponentUpdate(nextProps: Readonly<Props>, nextState: Readonly<State>, nextContext: any): boolean {
        var userHasChanged = this.state.currentUser != nextState.currentUser || this.state.currentUser?.email !== nextState.currentUser?.email;
        var shouldRenderChildrenHasChanged = this.state.shouldRenderChildren !== nextState.shouldRenderChildren;
        return userHasChanged || shouldRenderChildrenHasChanged;
    }

  updateContextAndCheckToken = (newUser: AuthUser) => {
    this.setState({ currentUser: newUser }, () => {
      this.updateUserBasedOnToken();
    });
  };

  async componentDidMount() {
    window.addEventListener('load', this.updateUserBasedOnToken);
    const config = await ConfigService.get();
    const currentUser = TokenService.GetUserFromToken();

    //Peridically check if user data has changed
    const userCheckInterval = setInterval(
      this.updateUserBasedOnToken,
      config.Security.cookieCheckIntervalMs || 2000
    );
    this.setState({ currentUser, shouldRenderChildren: !!currentUser, userCheckInterval });
  }

  componentWillUnmount() {
    window.removeEventListener('load', this.updateUserBasedOnToken);
    clearInterval(this.state.userCheckInterval);
  }

  updateUserBasedOnToken(): AuthUser | undefined {
    const tokenUser = TokenService.GetUserFromToken();
    const currentUser = this.state.currentUser;

    if (!tokenUser && !currentUser) {
      this.setState({ shouldRenderChildren: true });
      return;
    } else if (tokenUser && !currentUser) {
      this.setState({ currentUser: tokenUser, shouldRenderChildren: true });
      return;
    } else if (!tokenUser?.expirationTime?.isSame(currentUser?.expirationTime)) {
      this.setState({ currentUser: tokenUser, shouldRenderChildren: true });
      return;
    }
  }

  render() {
    return (
      <AuthContext.Provider value={{ Update: this.update, data: this.state.currentUser }}>
        {this.state.shouldRenderChildren && this.props.children}
      </AuthContext.Provider>
    );
  }
}










